import { Component } from 'react';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';

import {
    MediaProcessingItem,
    PROCESSING_PLACEHOLDER,
} from './MediaProcessingItem';

import { MediaType } from '../types/enums/mediatype.enum';

import savingImg from '../assets/saving.png';

class DraggablePhotos extends Component {
    renderDraggableItem = (item) => {
        const { type, object, onProcessingComplete, onProcessingError } =
            this.props;
        item = object ? item[object] : item;
        if (type === MediaType.VIDEO || item.uploading || item.errorText) {
            return this.renderPhoto(item);
        }
        if (item.processingStatus === 'error') {
            return this.renderPhoto({
                ...item,
                url: PROCESSING_PLACEHOLDER,
                errorText: 'Failed to process',
            });
        }
        if (item.processingStatus === 'in_progress') {
            return (
                <MediaProcessingItem
                    item={item}
                    onProcessingComplete={onProcessingComplete}
                    onProcessingError={onProcessingError}
                >
                    {(resolvedItem) => this.renderPhoto(resolvedItem)}
                </MediaProcessingItem>
            );
        }
        return this.renderPhoto(item);
    };

    renderPhoto = (item) => {
        const { onDelete, type } = this.props;
        const imageSize = this.props.imageSize || '@1x';
        return (
            <div
                style={{ userSelect: 'none' }}
                className={type === MediaType.VIDEO ? 'video' : 'photo'}
            >
                <div className="deletable">
                    {type !== MediaType.VIDEO && (
                        <img
                            style={{
                                height: this.props.height,
                                width: this.props.width,
                                objectFit: 'contain',
                            }}
                            src={item.url.replace('{0}', imageSize)}
                            alt={'id:' + item.id}
                        />
                    )}
                    {type === MediaType.VIDEO && (
                        <video
                            style={{
                                maxWidth: 450,
                                height: this.props.height,
                                width: this.props.width,
                                objectFit: 'contain',
                            }}
                            data-testid={'video:' + item.id}
                            controls
                        >
                            <source src={item.url} type="video/mp4" />
                        </video>
                    )}
                    {item.uploading && (
                        <div className="uploading">
                            {item.uploadingText ?? 'Uploading'}{' '}
                            <img
                                alt="loading"
                                className="loading"
                                style={{
                                    marginLeft: 10,
                                    marginBottom: -6,
                                    width: 22,
                                    opacity: 0.8,
                                }}
                                src={savingImg}
                            />
                        </div>
                    )}

                    {item.errorText && (
                        <div className="uploading uploadingError">
                            {item.errorText}
                        </div>
                    )}

                    {onDelete && (
                        <button
                            className="deleteIcon"
                            onClick={() => onDelete(item.idx, type)}
                            style={{ zIndex: 10 }}
                        />
                    )}
                </div>
            </div>
        );
    };

    render() {
        const { items, object, onDragEnd, type } = this.props;
        const draggableItems = items.map((item, idx) => ({
            idx,
            id: item.id,
            uploading: item.uploading,
            uploadingText: item.uploadingText,
            errorText: item.errorText,
            processingStatus: item.processingStatus,
            url: item.url,
            [object]: item[object],
        }));

        const handleDragEnd = (result) => {
            onDragEnd?.({
                source: {
                    index: result.source.index,
                    droppableId: type,
                },
                destination: { index: result.destination?.index },
            });
        };

        return (
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable
                    droppableId={`droppable-photos-${type}`}
                    direction="horizontal"
                >
                    {(provided) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                overflowX: 'auto',
                                gap: this.props.gap,
                                paddingTop: 20,
                                paddingBottom: 20,
                            }}
                        >
                            {draggableItems.map((item, index) => (
                                <Draggable
                                    key={`photo_draggable_${item.id}`}
                                    draggableId={`${item.id}_${item.id}`}
                                    index={index}
                                >
                                    {(dragProvided) => (
                                        <div
                                            ref={dragProvided.innerRef}
                                            {...dragProvided.draggableProps}
                                            {...dragProvided.dragHandleProps}
                                        >
                                            {this.renderDraggableItem(item)}
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    }
}

export default DraggablePhotos;
